// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Oswald);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container {
  position: absolute;
  justify-content: flex-end;
  padding-top: 23px;
}

.Login {
  background-color: transparent;
  border-color: transparent;
  color: rgb(255, 255, 255);
  transition: 0.3s;
  text-decoration: underline;
  font: 100 20px 'Oswald';
}

.Login:hover {
  color: orange;
}

.pfp {
  border-radius: 50%;
  width: 40px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./client/login/loginCss.css"],"names":[],"mappings":"AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd","sourcesContent":["@import url(//fonts.googleapis.com/css?family=Oswald);\r\n.Container {\r\n  position: absolute;\r\n  justify-content: flex-end;\r\n  padding-top: 23px;\r\n}\r\n\r\n.Login {\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  color: rgb(255, 255, 255);\r\n  transition: 0.3s;\r\n  text-decoration: underline;\r\n  font: 100 20px 'Oswald';\r\n}\r\n\r\n.Login:hover {\r\n  color: orange;\r\n}\r\n\r\n.pfp {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
